import { FormattedMessage } from 'react-intl';

import { SeasonEligibility } from '@sorare/core/src/__generated__/globalTypes';
import { FilterInDropdown } from '@sorare/core/src/atoms/dropdowns/FilterInDropdown';
import { SeasonalityIcon } from '@sorare/core/src/atoms/icons/SeasonalityIcon';
import { RadioGroup } from '@sorare/core/src/atoms/inputs/RadioGroup';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import { glossary } from '@sorare/core/src/lib/glossary';

import { SelectHeader } from 'atoms/SelectHeader';
import {
  ALL_VALUE,
  SeasonEligibilityOptions,
  seasonEligibilityOptionsMessages,
} from 'lib/seasonalities';

const seasonalities = [SeasonEligibility.IN_SEASON, SeasonEligibility.CLASSIC];

type Props = {
  seasonalityOptions?: SeasonEligibilityOptions[];
  withoutLabel?: boolean;
  fullWidth?: boolean;
  seasonality: SeasonEligibilityOptions;
  setSeasonality: (seasonality: SeasonEligibilityOptions) => void;
  buttonSize?: 'small' | 'medium' | 'compact' | undefined;
};

export const SelectSeasonality = ({
  seasonalityOptions = seasonalities,
  seasonality,
  setSeasonality,
  fullWidth = false,
  withoutLabel = false,
  buttonSize = 'small',
}: Props) => {
  const options = seasonalityOptions.map(s => ({
    label: (
      <Horizontal as="span" gap={2}>
        {s !== ALL_VALUE && <SeasonalityIcon seasonality={s} />}
        <FormattedMessage
          {...(s === ALL_VALUE
            ? glossary.all
            : seasonEligibilityOptionsMessages[s])}
        />
      </Horizontal>
    ),
    value: s,
  }));

  return (
    <FilterInDropdown
      buttonLabel={
        <Horizontal as="span" center className="text-center">
          {seasonality !== ALL_VALUE ? (
            <SeasonalityIcon seasonality={seasonality} />
          ) : (
            <FormattedMessage {...glossary.all} />
          )}
          {!withoutLabel && seasonality !== ALL_VALUE && (
            <FormattedMessage
              {...seasonEligibilityOptionsMessages[seasonality]}
            />
          )}
        </Horizontal>
      }
      buttonSize={buttonSize}
      fullWidth={fullWidth}
    >
      {({ closeDropdown }) => (
        <>
          <SelectHeader>
            <FormattedMessage
              id="SelectSeasonality.title"
              defaultMessage="Select seasonality"
            />
          </SelectHeader>
          <RadioGroup
            modalSelect
            options={options}
            value={seasonality}
            name="seasonality-selector"
            onChange={tf => {
              setSeasonality(tf);
              closeDropdown();
            }}
          />
        </>
      )}
    </FilterInDropdown>
  );
};
